import {
  types,
  // getParent
} from 'mobx-state-tree';

const Revenue = types.model('Revenue', {
  destinationFeesNumber: types.optional(types.number, 0),
  destinationFeesPercentage: types.optional(types.number, 0),
  profitNumber: types.optional(types.number, 0),
  profitPercentage: types.optional(types.number, 0),
  payPalFeesNumber: types.optional(types.number, 0),
  payPalFeesPercentage: types.optional(types.number, 0),
  productCostNumber: types.optional(types.number, 0),
  productCostPercentage: types.optional(types.number, 0),
  total: types.optional(types.number, 0),
}).views(self => ({
  get noRevenueData() {
    return (
      self.destinationFeesNumber === 0 &&
      self.destinationFeesPercentage === 0 &&
      self.profitNumber === 0 &&
      self.profitPercentage === 0 &&
      self.payPalFeesNumber === 0 &&
      self.payPalFeesPercentage === 0 &&
      self.productCostNumber === 0 &&
      self.productCostPercentage === 0 &&
      self.total === 0
    );
  },
  get revenueData() {
    return [
      {
        percents: self.productCostPercentage,
        number: self.productCostNumber,
        sectorId: 'productCost'
      },
      {
        percents: self.payPalFeesPercentage,
        number: self.payPalFeesNumber,
        sectorId: 'paypalFees'
      },
      {
        percents: self.destinationFeesPercentage,
        number: self.destinationFeesNumber,
        sectorId: 'destinationFees'
      },
      {
        percents: self.profitPercentage,
        number: Math.abs(self.profitNumber),
        sectorId: 'profit'
      },
    ]
  }
}));

export default Revenue;
